import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { flightSections } from "flights/flightSections";
import { Passengers } from "flights/passenger/Passengers";
import { useFlightDetail } from "flights/useFlightDetail";
import { getFlightFieldMetaData } from "shared/utils/fieldsHelper/flightFields";
import React from "react";
import { SidePanelLinkedShowList } from "../SidePanelLinkedShowList";
import { ButtonSecondary } from "components/Atoms/Button";
import { invalidateFlightsCache } from "utilities/api/flightQuery";
import { useQueryClient } from "@tanstack/react-query";

interface FlightSidePanelDetailsProps {
  flightSidePanelData: server.dto.FlightSidePanelData
  refetch: () => Promise<void>
}

export const FlightSidePanelDetails = (props: FlightSidePanelDetailsProps) => {
  const {
    state,
    onValueChanged,
    getUpdateFlightInstruction,
    isCreatingPassenger,
    setIsCreatingPassenger,
  } = useFlightDetail(
    props.flightSidePanelData.flight,
    props.flightSidePanelData.passengers,
  );

  const queryClient = useQueryClient();

  const onSuccessfulUpdateSidePanel = async () => {
    await props.refetch();
    invalidateFlightsCache(queryClient);
  }

  const fieldMetaData = getFlightFieldMetaData(site.currentEnvironment, state, props.flightSidePanelData.flight.permissions);

  const [flightSection, ...otherSections] = flightSections(state, fieldMetaData, getUpdateFlightInstruction);
  const sections = [{ ...flightSection, hideTitle: true }, ...otherSections];

  return <SidePanelDetailSectionTemplate
    isInPageEditable={props.flightSidePanelData.flight.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdateSidePanel}
    sections={sections}
    additionalContent={<>
      <div className="flex">
        <h3 className="grow1">{RESX.Flight.Passengers}</h3>
        {props.flightSidePanelData.flight.permissions.canModify && <ButtonSecondary
          label={RESX.Buttons.btnNew}
          onClick={() => setIsCreatingPassenger(true)}
        />}
      </div>
      <Passengers
        isInPageEditable={props.flightSidePanelData.flight.permissions.canModify}
        isCreating={isCreatingPassenger}
        setIsCreating={setIsCreatingPassenger}
        isInSidePanel
        isPrivateJet={props.flightSidePanelData.flight.flightType === "private"}
        flightId={props.flightSidePanelData.flight.flightId}
        passengers={state.passengers}
        refetchPassengers={props.refetch}
      />
      <SidePanelLinkedShowList
        linkedShows={props.flightSidePanelData.linkedShows}
        linkShowToTravel={{
          canLink: props.flightSidePanelData.flight.permissions.canModify,
          travelType: "flight",
          travelId: props.flightSidePanelData.flight.flightId,
          appointmentDateTime: props.flightSidePanelData.flight.dateTime,
          artist: props.flightSidePanelData.flight.artist,
          linkedShowIds: props.flightSidePanelData.linkedShows.map(show => show.showId),
          onLinked: props.refetch
        }}
      />
    </>}
  />
}
